module.exports = __webpack_public_path__ + "Roboto-Medium.574fd0b50367f886d359.woff2";


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/font/roboto/Roboto-Medium.woff2
// module id = ../../../../../src/libs/mdbootstrap/font/roboto/Roboto-Medium.woff2
// module chunks = styles